export const Step = {
  Basic: 0,
  Map: 1,
  Errand: 2,
  Managers: 2,
  Finish: 3
};
